export default function Checkmark({ className }: { className?: string }) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M13.8535 4.27299C14.2551 4.6522 14.2731 5.28511 13.8939 5.68663L8.22726 11.6866C8.04175 11.883 7.78467 11.996 7.51453 11.9999C7.24438 12.0038 6.98418 11.8981 6.79314 11.7071L3.79314 8.70711C3.40261 8.31659 3.40261 7.68342 3.79314 7.2929C4.18366 6.90237 4.81683 6.90237 5.20735 7.2929L7.47975 9.5653L12.4399 4.31338C12.8191 3.91186 13.452 3.89378 13.8535 4.27299Z" />
    </svg>
  );
}
